import { STAGES } from "@/constants/content";

const BUILT_STAGES = [1, 2, 3, 4];
const statusOf = (n, current) => {
  if (n === current) return "Active";
  if (!BUILT_STAGES.includes(n)) return "Coming next";
  return n < current ? "Completed" : "Upcoming";
};
const STATUS_CLS = {
  Completed: "border-emerald-400/40 bg-emerald-500/10 text-emerald-300",
  Active: "border-cyan-400/70 text-cyan-300",
  Upcoming: "border-white/10 text-slate-400",
  "Coming next": "border-amber-400/30 text-amber-300/90",
};
const TIER_CLS = {
  Start: "bg-[#2563EB]/15 text-blue-300",
  Free: "bg-emerald-500/10 text-emerald-300",
  "Free Preview": "bg-emerald-500/10 text-emerald-300",
  "Growth/Elite": "bg-violet-500/15 text-violet-300",
};

export const StepperGrid = ({ current, onSelect }) => (
  <nav aria-label="Founder journey stages" className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-5" data-testid="stepper-grid">
    {STAGES.map((s) => {
      const status = statusOf(s.n, current);
      const active = status === "Active";
      return (
        <button
          key={s.n}
          type="button"
          onClick={() => onSelect(s.n)}
          aria-current={active ? "step" : undefined}
          data-testid={`stepper-tile-${s.n}`}
          className={`iv-glass group grid min-w-0 grid-cols-[auto_1fr_auto] items-center gap-x-3 gap-y-1 rounded-xl px-3 py-2.5 text-left transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 sm:grid-cols-[auto_1fr] sm:items-start sm:gap-y-2 sm:p-3 ${
            active ? "!border-cyan-400/60 shadow-[0_0_0_1px_rgba(6,182,212,0.35),0_0_28px_rgba(6,182,212,0.18)]" : "hover:!border-white/20"
          }`}
        >
          <span className={`font-mono text-sm font-bold ${active ? "text-cyan-300" : "text-slate-500"}`}>{s.code}.</span>
          <span className="min-w-0 text-sm font-semibold leading-snug text-white sm:order-3 sm:col-span-2">{s.title}</span>
          <span className={`justify-self-end rounded-full border px-2 py-0.5 text-[10px] font-semibold sm:order-2 ${STATUS_CLS[status]}`} data-testid={`stepper-tile-${s.n}-status`}>
            {status}
          </span>
          <span className={`col-start-2 w-fit rounded-md px-2 py-0.5 text-[10px] font-semibold sm:order-4 sm:col-span-2 sm:col-start-1 ${TIER_CLS[s.tier]}`}>{s.tier}</span>
        </button>
      );
    })}
  </nav>
);
